module.exports = __webpack_public_path__ + "img/2.49cebc4e.png";